import {
  ApplicationConfig,
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
} from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { ENV_CONFIG } from '@ps/core-config';
import { provideAuthHydration } from '@ps/auth-data-access';
import { provideTrackerConfigDrawer } from '@ps/tracker-config-feature';
import { provideAppcues } from '@ps/core-data-access';
import { provideChurnzero, provideFullstory } from '@ps/core-tracking';

import { environment } from '../environments/environment';
import { StoreConfig } from './core/store/store.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { captchaInterceptor } from './interceptors/captcha.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { GlobalErrorHandler } from './interceptors/global-error-handler';
import { providePrimeNG } from 'primeng/config';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        captchaInterceptor,
        errorInterceptor,
        loadingInterceptor,
      ]),
    ),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    {
      provide: ENV_CONFIG,
      useValue: { ...environment },
    },
    ...StoreConfig(),
    provideAuthHydration(),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    providePrimeNG({
      unstyled: true,
    }),
    // CDK 21 renders overlays in the browser top layer (Popover API) by
    // default, which paints above every z-index and would break the overlay
    // ladder ($z-drawer < $z-dropdown < $z-toast < $z-loading). Keep overlays
    // in normal stacking so styles/tokens/_layout.scss stays authoritative.
    // CdkConnectedOverlay (dropdowns/selects/table filters) also honours this
    // token — a `false` here makes its internal popover location resolve to
    // null, so this single provider covers both global and connected overlays.
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideTrackerConfigDrawer(),
    provideAppcues(),
    provideFullstory(),
    provideChurnzero(),
  ],
};
